<template>
  <div v-if="Object.keys(gameStat).length > 0 && Object.keys(selectGame).length > 0">
    <header-game :close="!actions.goal.animation" :back="false"></header-game>
    <div class="game" :style="{background: `url(${getUrlBackgroundGame()}) no-repeat center center`}">
      <div class="container" v-if="!actions.goal.animation">
        <div class="game__status-bar">
          <div class="game__status-bar__actions">
            <div class="game__status-bar__actions__time" v-if="dataGame.joinGame">
              <!-- Timer flag -->
              <template v-if="selectGame.actions && Object.keys(selectGame.actions).length > 0 && selectGame.actions.flag">  
                <div class="game__status-bar__actions__time__flag" v-if="!actions.survey.active && !actions.throwPapers.active">
                  <div class="game__status-bar__actions__time__flag__icon">
                    <img src="@/assets/flag.svg" alt="">
                  </div>
                  <div class="game__status-bar__actions__time__flag__bar">
                    <div class="game__status-bar__actions__time__flag__bar__lapse" :style="{'width': `${gameStat.FlagsLevel}%`}"></div>
                  </div>
                </div>
              </template>
              <div class="game__status-bar__actions--row">
                <!-- Timer survey -->
                <div class="game__status-bar__actions__time__flag game__status-bar__actions__time__flag--violet" v-if="actions.survey.timer && actions.survey.active">
                  <vue-circle
                    :progress="100"
                    :size="72"
                    :reverse="false"
                    line-cap="round"
                    empty-fill="rgba(255, 255, 255, 1)"
                    :animation-start-value="1.0"
                    insert-mode="append"
                    :thickness="5"
                    :fill="fillLiga"
                    :show-percent = "false"
                    ref="progressCircle"
                    v-if="$config.MODE == 'SUPERLIGA'"
                    >
                      <img src="@/assets/timer.svg" alt="">
                  </vue-circle>
                  <vue-circle
                    :progress="100"
                    :size="72"
                    :reverse="false"
                    line-cap="round"
                    empty-fill="rgba(255, 255, 255, 1)"
                    :animation-start-value="1.0"
                    insert-mode="append"
                    :thickness="5"
                    :fill="fill"
                    :show-percent = "false"
                    ref="progressCircle"
                    v-else
                    >
                    <img src="@/assets/timer.svg" alt="">
                  </vue-circle>
                </div>
                <!-- Message survey -->
                <div class="game__status-bar__actions__survey__message" v-if="actions.survey.active && !actions.throwPapers.active">
                  {{actions.survey.data.questionText}}
                </div>
              </div>
              <!-- Timer confeti -->
              <div class="game__status-bar__actions__time__flag__confeti" v-if="actions.throwPapers.active">
                <h3>{{$t("actionGame.throwPapersBar")}}</h3>
                <div class="game__status-bar__actions__time__flag__confeti__bar">
                  <div class="game__status-bar__actions__time__flag__confeti__bar__lapse" :style="{width: `${getHeightBarThrowPapers(true)}%`}"></div>
                  <div class="game__status-bar__actions__time__flag__confeti__bar__line"></div>
                  <div class="game__status-bar__actions__time__flag__confeti__bar__line game__status-bar__actions__time__flag__confeti__bar__line--two"></div>
                  <div class="game__status-bar__actions__time__flag__confeti__bar__line game__status-bar__actions__time__flag__confeti__bar__line--three"></div>
                  <div class="game__status-bar__actions__time__flag__confeti__bar__line game__status-bar__actions__time__flag__confeti__bar__line--four"></div>
                </div>
              </div>
            </div>
          </div>
          <!-- Result match, time, live count -->
          <status-bar-match v-if="!actions.inflable.active && !actions.survey.active && !actions.throwPapers.active">
          </status-bar-match>
        </div>
        <!-- Livestream -->
        <transition name="fade" mode="out-in">
          <game-stream v-if="activeStream" :id="teamSelectedLocal ? selectGame.streamingUrlLocal : selectGame.streamingUrlVisitor" />
        </transition>
        <!-- Advertising -->
        <transition name="fade" mode="out-in">
          <game-advertising v-if="!activeStream && !this.actions.survey.active && !this.actions.throwPapers.active && !this.actions.goal.animation" :advertising="advertising" />
        </transition>
        <!-- Avatar -->
        <div class="game__avatar" v-if="avatarUrl != '' && (!actions.inflable.active || actions.survey.active || actions.throwPapers.active)"
          :class="{
            'game__avatar--papers':actions.throwPapers.active && !actions.survey.active,
            'game__avatar--survey':(actions.survey.active || actions.survey.results) && !actions.throwPapers.active,
            'game__avatar--advertising': advertising.length > 0 && !activeStream
          }">
          <transition name="fade" mode="out-in">
            <img :src="avatarUrl" alt="">
          </transition>
          <!-- Message normal -->
          <transition name="fade" mode="out-in">
            <div 
              class="game__avatar__message" 
              v-if="gameStat.Message != null && !actions.survey.active && !actions.throwPapers.active && !actions.goal.active && dataGame.joinGame"
              v-html="gameStat.Message">
            </div>
          </transition>
          <!-- Message survey  -->
          <!-- <transition name="fade" mode="out-in">
            <div class="game__avatar__message" v-if="actions.survey.active && !actions.survey.results && !actions.throwPapers.active">
              {{actions.survey.vote ? $t("actionGame.survey.awaitResult") : $t("actionGame.survey.vote")}}
            </div>
          </transition> -->
          <!-- Message paper -->
          <transition name="fade" mode="out-in">
            <div class="game__avatar__message" v-if="actions.throwPapers.active && !actions.survey.active">
              {{$t("actionGame.throwPapers")}}
            </div>
          </transition>
          <!-- Message Join game -->
          <transition name="fade" mode="out-in">
            <div class="game__avatar__message" v-if="!dataGame.joinGame && selectGame.actions && Object.keys(selectGame.actions).length > 0 && selectGame.actions.inflable">
              {{$t("actionGame.moveInflable")}}
            </div>
          </transition>
          <!-- Message Goal -->
          <transition name="fade" mode="out-in">
            <div class="game__avatar__message" v-if="actions.goal.active && !actions.throwPapers.active && !actions.survey.active">
              ¡GOOOOOOOLLLLLLLL!
            </div>
          </transition>
        </div>
        <!-- Survey -->
        <transition name="fade" mode="out-in">
          <div class="game__survey" v-if="actions.survey.active">
            <div class="game__survey__bg"></div>
            <div class="game__survey__button">
              <button 
                v-if="actions.survey.data.answerText01 != null" 
                @click="!isApp ? voteSurvey(1) : null"
                @touchstart="isApp ? voteSurvey(1) : null" 
                :class="{'disabled':actions.survey.vote && !actions.survey.results && actions.survey.voteValue != 1, 'selected': actions.survey.voteValue == 1 && !actions.survey.results}">
                  <div class="game__survey__button__result"
                  :style="{width: `${actions.survey.results ? `${actions.survey.data.answerValue01}%` : ''}`}"></div>
                  <span>{{actions.survey.data.answerText01}}</span>
                  <h4 v-if="actions.survey.results">{{actions.survey.data.answerValue01}}%</h4>
              </button>
            </div>
            <div class="game__survey__button">
              <button 
                v-if="actions.survey.data.answerText02 != null" 
                @click="!isApp ? voteSurvey(2) : null"
                @touchstart="isApp ? voteSurvey(2) : null" 
                :class="{'disabled':actions.survey.vote && !actions.survey.results && actions.survey.voteValue != 2, 'selected': actions.survey.voteValue == 2 && !actions.survey.results}">
                  <div class="game__survey__button__result"
                  :style="{width: `${actions.survey.results ? `${actions.survey.data.answerValue02}%` : ''}`}"></div>
                  <span>{{actions.survey.data.answerText02}}</span>
                  <h4 v-if="actions.survey.results">{{actions.survey.data.answerValue02}}%</h4>
              </button>
            </div>
            <div class="game__survey__button">
              <button 
                v-if="actions.survey.data.answerText03 != null" 
                @click="!isApp ? voteSurvey(3) : null"
                @touchstart="isApp ? voteSurvey(3) : null"  
                :class="{'disabled':actions.survey.vote && !actions.survey.results && actions.survey.voteValue != 3, 'selected': actions.survey.voteValue == 3 && !actions.survey.results}">
                  <div class="game__survey__button__result"
                  :style="{width: `${actions.survey.results ? `${actions.survey.data.answerValue03}%` : ''}`}"></div>
                  <span>{{actions.survey.data.answerText03}}</span>
                  <h4 v-if="actions.survey.results">{{actions.survey.data.answerValue03}}%</h4>
              </button>
            </div>
            <div class="game__survey__button">
              <button 
                v-if="actions.survey.data.answerText04 != null" 
                @click="!isApp ? voteSurvey(4) : null"
                @touchstart="isApp ? voteSurvey(4) : null"  
                :class="{'disabled':actions.survey.vote && !actions.survey.results && actions.survey.voteValue != 4, 'selected': actions.survey.voteValue == 4 && !actions.survey.results}">
                  <div class="game__survey__button__result"
                  :style="{width: `${actions.survey.results ? `${actions.survey.data.answerValue04}%` : ''}`}"></div>
                  <span>{{actions.survey.data.answerText04}}</span>
                  <h4 v-if="actions.survey.results">{{actions.survey.data.answerValue04}}%</h4>
              </button>
            </div>
            <div class="game__survey__message" v-if="actions.survey.active && !actions.survey.results && !actions.throwPapers.active">
              <img src="@/assets/help_outline-24px.svg" alt="">
              {{actions.survey.vote ? $t("actionGame.survey.awaitResult") : $t("actionGame.survey.vote")}}
            </div>
          </div>
        </transition>
        <!-- Confeti -->
        <transition name="fade" mode="out-in">
          <div class="game__confeti" v-if="actions.throwPapers.active || actions.throwPapers.showPapers">
            <div class="game__confeti__bg">
              <img src="@/assets/confeti.png" alt="" :style="{top: `${actions.throwPapers.showPapers ? '0' : `-100%`}`}">
            </div>
            <div class="game__confeti__bar" v-show="!actions.throwPapers.showPapers">
              <div class="game__confeti__bar__animation">
                <template v-for="a in actions.throwPapers.listAnimations">
                  <img src="@/assets/pelota_boton3.gif" alt="" :key="a">
                </template>
              </div>  
              <div class="game__confeti__bar__button" @touchstart="isApp ? throwPapers() : null" @click="!isApp ? throwPapers() : null">
                <button></button>
              </div>
            </div>
          </div>
        </transition>
        <!-- Inflable -->
        <transition name="fade" mode="out-in">
          <div class="game__inflable" v-show="actions.inflable.active && !actions.throwPapers.active && !actions.survey.active">
            <div class="game__inflable__bg">
              <img src="@/assets/confeti.png" alt="" :style="{top: `${actions.inflable.confeti ? '0' : '-100%'}`}">
            </div>
            <div class="game__inflable__container">
              <div class="game__inflable__container__body" :style="{height: `${actions.inflable.value}px`}">
                <img src="@/assets/inflable-body.svg" alt="" class="game__inflable__container__body__head">
                <img src="@/assets/inflable-base.svg" alt="" class="game__inflable__container__body__base">
              </div>
            </div>
            <div class="game__inflable__actions" v-if="!actions.inflable.confeti">
              <div class="game__inflable__button" :class="{'click-me': actions.inflable.value == 0}">
                  <button @touchstart="isApp ? addInflable() : null" @click="!isApp ? addInflable() : null">
                  <img src="@/assets/inflable-icon.svg" alt="">
                </button>
              </div>
            </div>
          </div>
        </transition>
        <!-- Actions -->
        <transition name="fade" mode="out-in">
          <div class="game__actions" v-if="!actions.survey.active && !actions.inflable.active && !actions.throwPapers.active">
            <template v-if="selectGame.actions && Object.keys(selectGame.actions).length > 0 && selectGame.actions.flag">  
              <div 
                class="game__actions__button game__actions__button--flag" 
                :class="{'active': actions.flag.active, 'disabled': actions.flag.timeout || !dataGame.joinGame, 'click-me': actions.flag.animation && !actions.flag.timeout && dataGame.joinGame && actions.flag.value == 0 && !actions.goal.active, 'fill': actions.flag.timeout}">
                <button @click="moveFlag()" :disabled="actions.flag.timeout || !dataGame.joinGame || actions.flag.animationMove"><img src="@/assets/flag.svg" alt=""></button>
                <div class="game__actions__button--flag__flag-bg" v-if="actions.flag.active" :style="{'width': `${actions.flag.value * 20}%`}"></div>
              </div>
            </template>  
            <template v-if="selectGame.actions && Object.keys(selectGame.actions).length > 0 && selectGame.actions.inflable">  
              <div class="game__actions__button" :class="{'hide': actions.flag.active, 'disabled': dataGame.joinGame, 'click-me': !dataGame.joinGame}">
                <button @touchstart="isApp ? activeInflable() : null" @click="!isApp ? activeInflable() : null" :disabled="dataGame.joinGame"><img src="@/assets/inflable-icon.svg" alt=""></button>
              </div>
            </template>
            <template v-if="selectGame.actions && Object.keys(selectGame.actions).length > 0 && selectGame.actions.camera.includes(gameStat.Status)">  
              <div class="game__actions__button" :class="{'hide': actions.flag.active, 'disabled': !dataGame.joinGame}">
                <button @touchstart="isApp ? goToCamera() : null" @click="!isApp ? goToCamera() : null" :disabled="!dataGame.joinGame"><img src="@/assets/cam.svg" alt=""></button>
              </div>
            </template>
            <template v-if="selectGame.actions && Object.keys(selectGame.actions).length > 0 && selectGame.actions.goal">
              <div class="game__actions__button" :class="{'hide': actions.flag.active, 'disabled': !actions.goal.active, 'click-me': actions.goal.active}">
                <button @touchstart="isApp ? showGoal() : null" @click="!isApp ? showGoal() : null" :disabled="!actions.goal.active"><img src="@/assets/goal.svg" alt=""></button>
              </div>
            </template>  
            <div class="game__actions__button" v-if="$config.MODE == 'SUPERLIGA' && selectGame.tutorial != ''">
              <button @click="goToTutorial"><img src="@/assets/tutorial.svg" alt=""></button>
            </div>
          </div>
        </transition>
      </div>
      <!-- Goal Animation -->
      <goal-animation :active.sync="actions.goal.animation" :animation="actions.goal.animationUrl"></goal-animation>  
    </div>
    <footer-sponsor></footer-sponsor>
  </div>
</template>

<script>
import persistentData from '@/plugins/persistentData'
import HeaderGame from '@/components/Header/Game.vue'
import FooterSponsor from '@/components/Footer/Sponsor.vue'
import GameStream from '@/components/Game/Stream.vue'
import GameAdvertising from '@/components/Game/Advertising.vue'
import StatusBarMatch from '@/components/Game/StatusBarMatch.vue'
import GoalAnimation from '@/components/Game/GoalAnimation.vue'
import { mapState } from 'vuex'
import moment from 'moment'
import Vibration from '@/plugins/vibration'
import VueCircle from 'vue2-circle-progress/src/index.vue'

export default {
  components: {
    HeaderGame,
    FooterSponsor,
    GameStream,
    GameAdvertising,
    VueCircle,
    StatusBarMatch,
    GoalAnimation
  },
  computed: {
    ...mapState({
      gameStat: state => state.InfoModule.gameStat,
      selectGame: state => state.InfoModule.selectGame,
      avatars: state => state.InfoModule.avatars,
      advertising: state => state.InfoModule.advertising
    }),
    activeStream: function() {
      if (this.dataGame.joinGame) {
        const isIdVideo = this.teamSelectedLocal ? this.selectGame.streamingUrlLocal : this.selectGame.streamingUrlVisitor
        return isIdVideo != '' && !this.actions.survey.active && !this.actions.throwPapers.active && !this.actions.goal.animation
      } else {
        return false
      }
    },
    isApp: function() {
      return window["cordova"] != undefined
    }
  },
  data() {
    return {
      dataGame: '',
      avatarUrl: '',
      teamSelectedLocal: '',
      fill: { color: "#E327E3" },
      fillLiga: {color: "#014B7A" },
      actions: {
        flag: {
          active: false,
          value: 0,
          timeout: false,
          valueTimeout: 0,
          animationMove: false,
          interval: null,
          animation: false,
          inactivity: null
        },
        survey: {
          active: false,
          vote: false,
          voteValue: 0,
          data: {},
          results: false,
          timer: false,
          totalTime: null,
          valueTimer: 0,
          interval: null
        },
        inflable: {
          active: false,
          value: 246,
          confeti: false
        },
        goal: {
          active: false,
          animation: false,
          animationUrl: ''
        },
        throwPapers: {
          id: 0,
          active: false,
          value: 0,
          maxValue: 0,
          myCount: 0,
          finished: false,
          goal: false,
          showPapers: false,
          listAnimations: [],
          data: {},
          message: "",
          startDateLocal: "",
          dueDateLocal: ""
        },
        camera: {
          active: true
        },
        intervalThrowPapers: null,
        idThrowActive: 0,
        idSurveyActive: 0
      },
      firstGameStat: true
    }
  },
  async created() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    // We listen to the resize event
    window.addEventListener('resize', () => {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
    const self = this
    this.dataGame = persistentData.getData(`game-${this.$route.params.id}`, true)
    if ( this.dataGame ) {
      // Verify model selectGame
      this.$store.dispatch('getGame', { id: this.dataGame.gameId}).then(async () => {
        this.teamSelectedLocal = this.dataGame.teamId == this.selectGame.teamLocal.id 
        const config = await this.$store.dispatch("getClientConfig")
        this.selectGame.actions = config.actions
        // Logic infable
        if (!this.selectGame.actions.inflable && !this.dataGame.joinGame) {
          this.dataGame.joinGame = true
          this.$store.dispatch('gameEnter', this.dataGame).then(res => {
            if (res == undefined) {
              this.$store.dispatch('openModalNoAccessGame')
            } else {
              persistentData.setData(`game-${this.dataGame.gameId}`, this.dataGame, true)
            }
          })
        }
      })
      
      // Inner game
      this.$store.dispatch('getGameStat', { id: this.dataGame.gameId, teamId: this.dataGame.teamId })
      this.$store.dispatch('userIsInGame', { gameId: Number(this.dataGame.gameId), teamId: Number(this.dataGame.teamId), avatarId: this.dataGame.avatarId })
      this.$store.dispatch('getAdvertising', { id: this.dataGame.gameId, teamId: this.dataGame.teamId })
      // Avatars
      if (this.avatars.length == 0) {
        this.$store.dispatch('getAvatars', { id: this.dataGame.teamId })
          .then(() => {
            self.getUrlAvatar()
          })
      } else {
        self.getUrlAvatar()
      }
      // Verify join game
      this.dataGame = persistentData.getData(`game-${this.dataGame.gameId}`, true)
    } else {
      this.$router.push(`/home/games`)
    }
  },
  methods: {
    getUrlBackgroundGame() {
      const isLocal = this.selectGame.teamLocal.id == this.dataGame.teamId
      const backgroundGameImage = isLocal ? this.selectGame.teamLocal.backgroundGameImage : this.selectGame.teamVisitor.backgroundGameImage
      if (backgroundGameImage != "") {
        return `${process.env.VUE_APP_CDN_URL_BACKGROUND_GAME_IMAGES}${backgroundGameImage}`
      } else {
        return `${process.env.VUE_APP_CDN_URL_BACKGROUND_GAME_IMAGES}background-match.jpg`  
      }
    },
    goToTutorial() {
      window.open(`${this.selectGame.tutorial}`, '_system');
    },
    getUrlAvatar() {
      const avatar = this.avatars.find(avatar => avatar.id == this.dataGame.avatarId)
      this.avatarUrl = avatar ? `${process.env.VUE_APP_CDN_URL_AVATARS}${avatar.avatar}` : ''
    },
    goToCamera() {
      if (this.dataGame.joinGame) {
        // Enable button flag
        this.actions.flag.timeout = false;
        this.actions.flag.value = 0;
        this.intervalDisabledFlag(true)
        this.$router.push(`/game/${this.dataGame.gameId}/${this.dataGame.teamId}/picture`)
      }
    },
    moveFlag() {
      if (this.dataGame.joinGame && !this.actions.flag.timeout && !this.actions.flag.animationMove) {
        this.actions.flag.active = true;
        this.actions.flag.value ++;
        // Disabled while execute animation in bar
        this.actions.flag.animationMove = true
        setTimeout(() => {this.actions.flag.animationMove = false}, 500)
        if (this.actions.flag.value == 5) {
          this.actions.flag.active = false;
          this.actions.flag.timeout = true;
          this.actions.flag.valueTimeout = 5;
          this.intervalDisabledFlag()
          if (this.actions.flag.inactivity != null) clearTimeout(this.actions.flag.inactivity)
          
          setTimeout(() => {
            this.actions.flag.timeout = false;
            this.actions.flag.value = 0;
            this.intervalDisabledFlag(true)
          }, 60000)
          this.$store.dispatch("waveFlags", {
            teamId: this.dataGame.teamId,
            gameId: this.dataGame.gameId
          })
        }

        // Verify activity and disabled flagActive
        if (this.actions.flag.inactivity != null) clearTimeout(this.actions.flag.inactivity)

        this.actions.flag.inactivity = setTimeout(() => {
          this.actions.flag.active = false;
          this.actions.flag.value = 0;
        }, 10000)
      }
    },
    intervalDisabledFlag(clear = false) {
      if (!clear) {
        this.actions.flag.interval = setInterval(() => {
          if (this.actions.flag.valueTimeout > 0) this.actions.flag.valueTimeout --;
        }, 1000)
      } else {
        this.actions.flag.valueTimeout = 0;
        clearInterval(this.actions.flag.interval)
      }
    },
    async voteSurvey(option) {
      if (this.actions.survey.vote || this.actions.survey.results) return

      const vote = await this.$store.dispatch('voteSurvey', {
        surveyId: Number(this.gameStat.ActionId),
        option
      })
      if (vote.status == 200) {
        persistentData.setData(`game-${this.dataGame.gameId}-survey-${this.gameStat.ActionId}`, {
          vote: true,
          result: false
        }, true)
        this.actions.survey.vote = true;
        this.actions.survey.voteValue = Number(option)
      }
    },
    closeSurvey () {
      this.actions.survey = {
        active: false,
        vote: false,
        data: {},
        results: false,
        timer: false,
        totalTime: null,
        valueTimer: 0,
        interval: null
      }
      this.intervalSurvey(true)
    },
    async getSurvey(result) {
      // Verificar si es necesario llamarlo
      let survey;
      if (Object.keys(this.actions.survey.data).length > 0 && !result) {
        survey = this.actions.survey
      } else {
        survey = await this.$store.dispatch('getSurvey', {surveyId: this.gameStat.ActionId})
        if (survey.status == 200) {
          this.actions.survey.data = survey.data
          this.actions.survey.results = result
          this.actions.survey.timer = !result
          this.idSurveyActive = this.gameStat.ActionId
          // Diff dates
          const diffSecondsDueDate = moment(survey.data.dueDate).diff(moment(survey.data.currentDate), 'seconds')
          this.actions.survey.dueDateLocal = moment().add(diffSecondsDueDate, 'seconds')
          const diffSecondsStartDate = moment(survey.data.startDate).diff(moment(survey.data.currentDate), 'seconds')
          this.actions.survey.startDateLocal = moment().add(diffSecondsStartDate, 'seconds')

          survey = this.actions.survey
          if (result) {
            setTimeout(() => {
              this.closeSurvey()
            }, 20000)
          }
        }
      }
      
      // Verificar que el current sea menor que el dueDate
      if ((moment().diff(moment(survey.startDateLocal), 'seconds') > 0 && moment().diff(moment(survey.dueDateLocal), 'seconds') < 0) || result) {
        this.actions.survey.active = true
        this.actions.survey.results = result
        this.actions.survey.timer = !result
        if (this.actions.survey.totalTime == null) this.actions.survey.totalTime = moment(survey.dueDateLocal).diff(moment(), 'seconds') 
        this.intervalSurvey()
        // Enable button flag
        this.actions.flag.timeout = false;
        this.actions.flag.value = 0;
        this.intervalDisabledFlag(true)
      }
    },
    getTimerSurvey() {
      const dueDateLocal = moment(this.actions.survey.data.dueDate).local().format()
      if (this.actions.survey.timer && this.actions.survey.active) {
        this.actions.survey.valueTimer = Math.round((moment(dueDateLocal).diff(moment(), 'seconds') * 100) /  this.actions.survey.totalTime)
        if (this.actions.survey.valueTimer >= 0) {
          this.$refs.progressCircle.updateProgress(this.actions.survey.valueTimer)
        }
      }
    },
    intervalSurvey(clear = false) {
      if (!clear) {
        this.actions.survey.interval = setInterval(() => {
          this.getTimerSurvey()
        }, 1000)
      } else {
        clearInterval(this.actions.survey.interval)
      }
    },
    activeInflable() {
      if(!this.dataGame.joinGame)
      {
        this.actions.inflable.active = true;
      }
    },
    async addInflable() {
      this.actions.inflable.value += 25;
      if (this.actions.inflable.value > 450) {
        this.actions.inflable.confeti = true;
        // Vibration.vibration()
        this.$store.dispatch('soundMessage')
        const request = await this.$store.dispatch('gameEnter', this.dataGame)
        if (request.status == 200) {
          setTimeout(() => {
            this.dataGame.joinGame = true
            persistentData.setData(`game-${this.dataGame.gameId}`, this.dataGame, true)
            this.actions.inflable = {
              active: false,
              value: 0,
              confeti: false
            }
          }, 5000)
        }
      }
    },
    activeGoal() {
      persistentData.setData(`game-${this.dataGame.gameId}-goal-${this.gameStat.ActionId}`, {
        show: true
      }, true)
      this.actions.goal.active = true;
      setTimeout(() => {
        this.actions.goal.active = false;
      }, 60000)
    },
    showGoal() {
      if (this.dataGame.joinGame) {
        persistentData.setData(`game-${this.dataGame.gameId}-goal-${this.gameStat.ActionId}`, {show: true}, true)
        this.actions.goal.animation = true;
        // Enable button flag
        this.actions.flag.timeout = false;
        this.actions.flag.value = 0;
        this.intervalDisabledFlag(true)
        setTimeout(() => {
        //   this.actions.goal.animation = false;
          this.actions.goal.active = false;
        }, 5000) 
      }
    },
    throwPapers() {
      this.actions.throwPapers.value ++;
      this.actions.throwPapers.myCount ++;
      setTimeout(() => {
        this.actions.throwPapers.listAnimations.push(`${this.actions.throwPapers.value}`)
        setTimeout(() => {
          this.actions.throwPapers.listAnimations.shift()
        }, 2500)
      }, 250)
    },
    sumThrowPapers() {
      this.intervalThrowPapers = setInterval(() => {
        const pd_thowPapers = persistentData.getData(`game-${this.dataGame.gameId}-throwPapers-${this.idThrowActive}`, true)
        if (pd_thowPapers != null && (this.actions.throwPapers.finished || this.actions.throwPapers.goal) && this.actions.throwPapers.showPapers) {
          this.actions.throwPapers = {
            active: false,
            value: 0,
            maxValue: 0,
            myCount: 0,
            finished: false,
            goal: false,
            showPapers: false,
            data: {},
            message: "",
            startDateLocal: "",
            dueDateLocal: ""
          }
          return
        } 
        const myCountLocal = this.actions.throwPapers.myCount
        this.actions.throwPapers.myCount = 0
        if (moment().diff(moment(this.actions.throwPapers.startDateLocal), 'seconds') > 0) {
          this.$store.dispatch('throwPapers', {
            "actionId": pd_thowPapers.id,
            "hitCount": myCountLocal
          }).then(res => {
            this.actions.throwPapers.active = true
            this.actions.throwPapers.value = res.data.totalHits > this.actions.throwPapers.value ? res.data.totalHits : this.actions.throwPapers.value 
            this.actions.throwPapers.maxValue = res.data.goalThreshold
            this.actions.throwPapers.finished = res.data.finished
            this.actions.throwPapers.goal = res.data.goal
            this.actions.throwPapers.message = pd_thowPapers.message
            persistentData.setData(`game-${this.dataGame.gameId}-throwPapers-${this.idThrowActive}`, {
              finished: this.actions.throwPapers.finished,
              goal: this.actions.throwPapers.goal,
              id: pd_thowPapers.id,
              showPapers: false,
              data: pd_thowPapers.data,
              message: pd_thowPapers.message
            }, true)
           // Enable button flag
            this.actions.flag.timeout = false;
            this.actions.flag.value = 0;
            this.intervalDisabledFlag(true)
          })
        }
      }, 500)
    },
    getHeightBarThrowPapers(positive) {
      let result = this.actions.throwPapers.value * 100 / this.actions.throwPapers.maxValue
      if (positive) {
        return result
      } else if ((result - 100) > 0) {
        return 0
      } else {
        return result - 100
      }
    }
  },
  watch: {
    async gameStat() {
      if (this.dataGame.joinGame && this.$route.name == 'ScreenGame' && this.gameStat.Status != 'finished') {
        if (this.gameStat.ActionType == 'survey') {
          // Verify not vote
          const pd_action = persistentData.getData(`game-${this.dataGame.gameId}-survey-${this.gameStat.ActionId}`, true)
          // Validar que no tenga guardada la misma encuesta
          this.actions.survey.timer = true
          if (pd_action) {
            this.getSurvey(false)
            if (Object.keys(this.actions.survey.data).length == 0) {
              this.actions.survey.results = pd_action.results
              this.actions.survey.vote = pd_action.vote
            }
          } else {
            persistentData.setData(`game-${this.dataGame.gameId}-survey-${this.gameStat.ActionId}`, {
              vote: false,
              result: false
            }, true)
            this.getSurvey(false)
          }
        }
        if (this.gameStat.ActionType == 'surveyResults') {
          this.actions.survey.timer = false
          const pd_action = persistentData.getData(`game-${this.dataGame.gameId}-survey-${this.gameStat.ActionId}`, true)
          if (pd_action != null && !pd_action.results && this.idSurveyActive == this.gameStat.ActionId) { 
            this.getSurvey(true)
            persistentData.setData(`game-${this.dataGame.gameId}-survey-${this.gameStat.ActionId}`, {
              vote: pd_action.vote,
              results: true
            }, true)
          }
        }
        if (this.gameStat.ActionType == 'showanimation') {
          // Goal
          const keyPersistentData = `game-${this.dataGame.gameId}-goal-${this.gameStat.ActionId}`
           
          if (this.firstGameStat) {
            persistentData.setData(keyPersistentData, {show: true}, true)
          } else {
            const pd_goal = persistentData.getData(keyPersistentData, true)
            if (pd_goal == null) {
              this.selectGame.actions.goal ? this.activeGoal() : this.showGoal()
              this.actions.goal.animationUrl = this.gameStat.ActionExtraData
            }
          }
        }
        if (this.gameStat.ActionType == 'throwpapers') {
          const pd_thowPapers = persistentData.getData(`game-${this.dataGame.gameId}-throwPapers-${this.gameStat.ActionId}`, true)
          const self = this
          if (pd_thowPapers == null || Object.keys(this.actions.throwPapers.data).length == 0) {
            this.$store.dispatch('gameActionDetail', {id : this.gameStat.ActionId})
              .then(res => {
                self.actions.throwPapers.message = res.data.extraData
                self.actions.throwPapers.data = res.data
                self.actions.throwPapers.value = 0;
                self.actions.throwPapers.myCount = 0;
                self.idThrowActive = Number(res.data.id)
                // Diff dates
                // TODO verificar esto gap
                const diffSecondsDueDate = moment(self.actions.throwPapers.data.dueDate).diff(moment(self.actions.throwPapers.data.currentDate), 'seconds')
                const gapSecondsDueDate = moment(self.actions.throwPapers.data.dueDate).diff(moment(self.actions.throwPapers.data.currentDate), 'hours') * 3600
                self.actions.throwPapers.dueDateLocal = (moment().add(diffSecondsDueDate - gapSecondsDueDate, 'seconds'))
                const diffSecondsStartDate = moment(self.actions.throwPapers.data.startDate).diff(moment(self.actions.throwPapers.data.currentDate), 'seconds')
                const gapSecondsStartDate = moment(self.actions.throwPapers.data.dueDate).diff(moment(self.actions.throwPapers.data.currentDate), 'hours') * 3600
                self.actions.throwPapers.startDateLocal = (moment().add(diffSecondsStartDate - gapSecondsStartDate, 'seconds'))
                
                persistentData.setData(`game-${self.dataGame.gameId}-throwPapers-${self.idThrowActive}`, {
                  finished: false,
                  goal: false,
                  id: self.idThrowActive,
                  showPapers: false,
                  data: res.data,
                  message: res.data.extraData
                }, true)

                self.sumThrowPapers()
              })
          }
        }
        if (this.gameStat.ActionType == 'throwPapersFinish') {
          if (Number(this.idThrowActive) == Number(this.gameStat.ActionId)) {
            clearInterval(this.intervalThrowPapers)
            const pd_thowPapers = persistentData.getData(`game-${this.dataGame.gameId}-throwPapers-${this.idThrowActive}`, true)
            if (pd_thowPapers != null && !pd_thowPapers.showPapers && !this.actions.throwPapers.showPapers) {
              if (this.gameStat.ActionExtraData == 'goal') {
                this.actions.throwPapers.showPapers = true
              }
              setTimeout(() => {
                this.actions.throwPapers.showPapers = false
                this.actions.throwPapers.active = false
                this.actions.throwPapers.value = 0;
                this.actions.throwPapers.myCount = 0;
                persistentData.setData(`game-${this.dataGame.gameId}-throwPapers-${this.idThrowActive}`, {
                  finished: false,
                  goal: false,
                  id: this.gameStat.ActionId,
                  showPapers: true,
                  data: pd_thowPapers.data,
                  message: pd_thowPapers.data.extraData
                }, true)
              }, 5500)
            }
          }
        }
        if (this.firstGameStat) this.firstGameStat = false;
      }

      // Verify Finish match
      if (this.dataGame.joinGame && this.gameStat.Status == 'finished') {
        this.$store.dispatch("openModalFinishGame")
      }
    },
    'actions.goal.active': function (val) {
      if (val) {
        Vibration.vibration()
        this.$store.dispatch('soundMessage')
      }
    },
    'actions.goal.animation': function (val) {
      if (val) {
        Vibration.vibration([1000, 500, 1000, 500, 1000, 500])
        //this.$store.dispatch('soundGoal')
      }
    },
    'actions.survey.active': function (val) {
      if (val) {
        Vibration.vibration()
        this.$store.dispatch('soundMessage')
      } else {
        const self = this;
        window.removeEventListener('click', self.closeSurvey);
      }
    },
    'actions.survey.results': function (val) {
      if (val) {
        Vibration.vibration()
        this.$store.dispatch('soundMessage')
        // Capture click
        const self = this
        window.addEventListener('click', self.closeSurvey );
      }
    },
    'actions.throwPapers.active': function (val) {
      if (val) {
        Vibration.vibration()
        this.$store.dispatch('soundMessage')
      }
    },
    'actions.throwPapers.showPapers': function (val) {
      if (val) Vibration.vibration()
    },
    'gameStat.Message': function (val) {
      if (val!= null && val != '') {
        Vibration.vibration()
        this.$store.dispatch('soundMessage')
        this.actions.flag.animation = (val.toLowerCase().indexOf("alent") > -1 || val.toLowerCase().indexOf("bandera") > -1)
      }
    }
  }
}
</script>

<style lang="scss">
  @import '@/styles/_variables';

  .game {
    
    .container {
      position: relative;
      height: 100vh;
      min-height: 360px;
      height: calc(var(--vh, 1vh) * 100);
      overflow: hidden;
    }

    .game__status-bar {
      display: flex;
      justify-content: space-between;
      margin-top: 80px;
      padding-right: $margin-base;
      position: relative;
      z-index: 3;

      .game__status-bar__actions {
        padding-left: $margin-base;
        padding-right: $margin-base;
        max-width: 240px;
        width: 100%;

        &--row {
          display: flex;
          flex-direction: row;
          align-items: center;
          width: calc(100% - 32px);
          position: absolute;
          left: 0;
          padding: 0 $gap-base;
          margin: 0 $gap-base;
          max-width: 480px;
          background: $violet;
          border-radius: $margin-base / 2;

          @media (min-width: $break-sm) {
            width: 100%;
          }

          @media (min-width: $break-lg) {
            right: 120px;
            left: auto;
            margin-right: 0;
          }
        } 

        .circle {
          margin-right: $margin-base;
        }

        &__survey__message {
          color: $white;
          font-weight: 600;
          @include font-settings(base,base);
          margin: 0;
          flex-shrink: 1;
          padding: $margin-base 0;
          background: $violet;
          border-radius: $margin-base / 2;

          @media (min-width: $break-md) {
            @include font-settings(kilo,base);
          }
        }

        .game__status-bar__actions__time {
          margin-bottom: $margin-milli;

          &__flag {
            display: flex;
            max-width: 240px;
            width: 100%;
            align-items: center;

            &__icon {
              height: 40px;
              width: 40px;
              background: $violet;
              border-radius: $redondeadobig;
              padding: $margin-milli / 2;
              flex-shrink: 0;
              display: flex;
              justify-content: center;
              align-items: center;

              img {
                width: 21px;
              }
            }

            &__bar {
              height: 24px;
              border-radius: 0 $margin-base $margin-base 0;
              border: 2px solid $violet;
              background: #fffc;
              max-width: 160px;
              width: 100%;
              position: relative;
              overflow: hidden;
              margin-left: -2px;

              &__lapse {
                background: $lightviolet;
                height: 28px;
                width: 0;
                transition: width 1s ease-in-out;
                opacity: .8;
              }
            }

            &__confeti {
              position: absolute;
              max-width: 360px;
              width: calc(100% - 32px);
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              @media (min-width: $break-md) {
                right: 0;
                margin-top: 80px;
              }

              h3 {
                color: $white;
                font-size: 16px;
                margin-bottom: $margin-milli;
              }

              &__bar {
                height: 24px;
                border-radius: $margin-milli;
                border: 2px solid white;
                background: #B6C6DC;
                width: 100%;
                position: relative;
                overflow: hidden;

                &__line {
                  position: absolute;
                  width: 2px;
                  background: $white;
                  height: 14px;
                  top: 0;
                  left: 20%;

                  &--two {
                    left: 40%;
                  }

                  &--three {
                    left: 60%;
                  }

                  &--four {
                    left: 80%;
                  }
                }

                &__lapse {
                  background: linear-gradient(-90deg, #440358,$lightblue);
                  height: 28px;
                  transition: width 1s ease-in-out;
                }
              }
            }

            &--violet {
              max-width: fit-content;
              
              .game__status-bar__actions__time__flag__icon {
                background: $violet;
              }

              .game__status-bar__actions__time__flag__bar {
                border: 2px solid $violet;

                &__lapse {
                  background: $violet;
                }
              }
            }
          }
        }
      }
    }

    .game__avatar {
      position: fixed;
      left: 45%;
      bottom: -80px;
      width: 420px;
      z-index: 2;
      margin-left: -340px;

      @media (min-width: 321px) {
        left: 50%;
      }

      @media (min-width: $break-md) {
        position: absolute;
        left: 0;
        margin-left: 0;
        bottom: -40px;
        width: 560px; 
      }

      @media (max-height: 480px) {
        bottom: -120px;
      }

      &--papers {
        margin-left: -330px!important;

        @media (min-width: $break-md) {
          margin-left: 0!important;
        }
      }

      &--survey {
        display: none;

        @media (min-width: $break-lg) {
          display: block;
        }
      }

      &__message {
        position: absolute;
        bottom: 260px;
        left: 250px;
        font-weight: 600;
        font-style: italic;
        background: $white;
        color: $blue;
        padding: $margin-milli $margin-base;
        border-radius: $margin-base $margin-base $margin-base 0px;
        box-shadow: $shadow;

        a {
          text-decoration: underline;
        }

        @media (min-width: $break-md) {
          bottom: 350px;
          left: 330px;
        }
      }
    }

    .game__actions {
      position: absolute;
      bottom: 80px;
      right: 0;
      display: flex;
      justify-content: space-between;
      width: 100%;
      z-index: 3;
      padding-bottom: env(safe-area-inset-bottom);

      @media (min-width: $break-md) {
        justify-content: flex-end;
        max-width: 480px;
      }

      @media (min-width: $break-lg) {
        right: 120px;
        width: 480px;
      }

      @media (min-width: $break-lg) and (min-height: 768px) {
        bottom: 104px;
      }

      .game__actions__button {
        height: 64px;
        width: 64px;
        position: relative;
        transition: width .5s ease-in-out, opacity .5s ease-in-out;
        margin-right: $margin-base;
        margin-top: $margin-base;

        &:first-child {
          margin-left: $margin-base;

          @media (min-width: $break-md) {
            margin-left: 0;
          }
        }
        
        button {
          width: 64px;
          height: 100%;
          z-index: 2;
          color: $white;
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 3px solid $lightblue;
          border-radius: $margin-base;
          background: #07559D;
          box-shadow: $shadow;

          &:active {
            transform: scale(1.1);
          }

          img {
            width: 38px;
          }
        }

        &.click-me {

          button {
            animation: jittery 2s infinite;
          }
        }
        
        &.active {
          width: 100%;
          margin-right: 0;
          border: 3px solid $violet;
          border-radius: $margin-kilo;
          background: #fffc;
          margin-right: $margin-base;
          box-shadow: $shadow;
          height: 40px;
          bottom: -$margin-small;

          button {
            background: #8E478D;
            border: 3px solid $violet;
            position: absolute;
            height: 64px;
            left: -3px;
            top: -$margin-base;
          }
        }

        &.hide {
          opacity: 0;
          width: 0;
          margin-right: 0;
        }

        &.disabled {

          button {
            box-shadow: none;
            cursor: initial;
            opacity: .6;

            &:active {
              transform: scale(1);
            }
          }
        }

        &--flag {

          &.fill {
            position: relative;

            button {
              overflow: hidden;
              opacity: 1;
              background: #80278040;

              &:before {
                content: '';
                width: 100%;
                height: 100%;
                z-index: -1;
                position: absolute;
                background: #07559D;
                left: 0;
                //animation: flagButton 60s 0.1s cubic-bezier(.17,.67,.83,.67);
                transition: width 60s cubic-bezier(.17,.67,.83,.67);
              }
            }
          }
          
          button {
            &:before {
                content: '';
                width: 0%;
                height: 100%;
                z-index: -1;
                position: absolute;
                background: transparent;
                left: 0;
                animation: none;
              }
          }

          @keyframes flagButton {
            0% {
              width: 0;	
            }
            50% {
              width: 50%;
            }	
            100% {
              width: 100%;
            }
          }
        }

        &--flag__flag-bg {
          position: absolute;
          background: $lightviolet;
          top: 0;
          height: 34px;
          z-index: 1;
          transition: width .5s ease-in-out;
        }
      }
    }

    .game__inflable {
      position: absolute;
      bottom: 48px;
      right: 16px;

      .game__inflable__bg {
        position: fixed;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        left: 0;
        top: 0;
        z-index: 0;
        background: #21012b66;

        img {
          position: relative;
          top: -50%;
          transition: top .5s ease;
          transition-duration: 5s;
        }
      }

      .game__inflable__container {
        position: fixed;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        left: 0;
        top: 0;
        z-index: 3;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;

        &__body {
          width: 240px;
          position: relative;
          overflow: hidden;
          min-height: 246px;
          max-height: 456px;
          height: 80vh;
          bottom: 80px;

          @media (max-height: 480px) {
            bottom: -20px;
          }

          // &__head {
            // animation: floater 2.5s infinite;
          // }

          &__base {
            position: absolute;
            width: 96px;
            bottom: 0;
            left: 50%;
            margin-left: -68px;
          }
        }
      }

      @keyframes floater {
        0% {
          transform: translateY(0%);	
        }
        50% {
          transform: translateY(8%);	
        }	
        100% {
          transform: translateY(0%);
        }
      }

      .game__inflable__actions {
        position: absolute;
        bottom: 40px;
        right: 0;
        display: flex;
        width: 240px;
        z-index: 3;
        justify-content: flex-end;
        padding-bottom: env(safe-area-inset-bottom);

        @media (min-width: $break-lg) {
          bottom: 56px;
          right: 120px;
          width: 480px;
        }

        .game__inflable__button {
          height: 64px;
          width: 64px;
          position: relative;
          transition: all .5s ease-in-out;
          margin-right: $margin-base;

          button {
            width: 64px;
            height: 100%;
            z-index: 2;
            color: $white;
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 3px solid $lightblue;
            border-radius: $margin-base;
            background: #07559D;
            box-shadow: $shadow;

            &:active {
              transform: scale(1.1);
            }

            img {
              width: 38px;
            }
          }

          &.click-me {

            button {
              animation: jittery 2s infinite;
            }
          }
        }
      }
    }

    .game__confeti {
      position: absolute;
      bottom: 80px;
      right: 16px;
      padding-bottom: env(safe-area-inset-bottom);

      .game__confeti__bg {
        position: fixed;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        left: 0;
        top: 0;
        z-index: 0;
        background: #21012b66;

        img {
          position: relative;
          top: -50%;
          transition: top 5s ease;
        }
      }

      .game__confeti__bar {
        width: 96px;
        border-radius: 48px;
        padding: $margin-small;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        position: relative;

        &:after {
          content: '';
          display: block;
          width: 88px;
          height: 88px;
          position: absolute;
          background: linear-gradient(rgba(33, 1, 43, 0.9),rgba(0, 106, 196, .9));
          z-index: 0;
          border-radius: 50%;
          left: 4px;
          bottom: 4px;
          animation: shadowfall 1s infinite;
        }

        &__animation {
          position: relative;

          img {
            width: 96px;
            position: absolute;
            bottom: 80px;
            left: -12px;
            animation: ballAnimation 2.5s ease-in-out;
            animation-delay: .1s;
          }

          @keyframes ballAnimation {
            0%   { opacity:0; }
            50%  { opacity:.8; }
            100% { opacity:0;}
          }
        }

        &__button {
          width: 72px;
          height: 72px;
          z-index: 2;
          border: 1px solid $white;
          border-radius: 50%;
          position: absolute;
          padding: $margin-milli / 2;

          button {
            background: $white;
            border-radius: 50%;
            width: 100%;
            height: 100%;
          }

          &:active {
            transform: scale(1.1);
          }
        }
      }

      @-webkit-keyframes shadowfall {
        0% { box-shadow: 0px 0px 32px 0px rgba(33,1,43,0.75); }
        50% { box-shadow: 0px 0px 32px 10px rgba(33,1,43,0.75); }
        100% { box-shadow: 0px 0px 32px 0px rgba(33,1,43,0.75); }
      }

      @keyframes shadowfall {
        0% { box-shadow: 0px 0px 32px 0px rgba(33,1,43,0.75); }
        50% { box-shadow: 0px 0px 32px 10px rgba(33,1,43,0.75); }
        100% { box-shadow: 0px 0px 32px 0px rgba(33,1,43,0.75); }
      }
    }

    .game__survey {
      position: absolute;
      bottom: 80px;
      right: 0;
      display: flex;
      width: calc( 100% - 32px );
      flex-direction: column;
      align-items: flex-start;
      margin: 0 $margin-base;
      height: 340px;
      flex-wrap: wrap;
      justify-content: flex-end;

      @media (max-width: 320px) and (max-height: 516px) {
        bottom: $margin-base;
      }

      .game__survey__bg {
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 0;
        background: #21012b66;
      }

      @media (min-width: $break-lg) {
        bottom: 104px;
        right: 120px;
        width: 480px;
        margin-right: 0;
      }

      &__message {
        position: relative;
        display: flex;
        align-items: center;
        // margin-top: $margin-base;
        font-weight: 500;
        font-style: italic;
        font-size: 13px;
        background: $white;
        color: $gray;
        padding: $margin-milli $margin-base;
        border-radius: $margin-base;

        img {
          width: 21px;
          margin-right: $margin-milli / 2;
        }
      }

      .game__survey__button {
        position: relative;
        transition: all .5s ease-in-out;
        margin-bottom: $margin-base;
        width: 100%;

        &__result {
          position: absolute;
          height: 100%;
          background: $lightblue;
          border-radius: $margin-milli;
          z-index: 0;
          bottom: 0;
          left: 0;
        }

        button {
          height: 100%;
          width: 100%;
          z-index: 2;
          color: $white;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 2px solid $lightblue;
          border-radius: $margin-milli;
          background: $blue;
          box-shadow: $shadow;
          flex-direction: row;
          padding: $margin-milli;
          font-weight: 700;
          text-transform: uppercase;
          @include font-settings(milli, base);
          font-family: $font-barlow;

          &:active {
            transform: scale(1.1);
          }

          span {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical; 
            word-break: break-word;
            z-index: 1;
          }

          h4 {
            z-index: 1;
            margin-left: $margin-base;
          }

          img {
            width: 32px;
            margin-bottom: $margin-milli;
          }

          &.selected {
            opacity: 1!important;
            background: $blue;
            cursor: none;

            &:active {
              transform: scale(1);
            }
          }

          &.disabled {
            background: $blue;
            box-shadow: none;
            cursor: initial;
            opacity: .6;

            &:active {
              transform: scale(1);
            }
          }
        }
      }
    }
  }
</style>